/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeSXIcon20Solid = forwardRef('MediaAudioVolumeSXIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m4.632 6 4.301-3.715c.81-.7 2.067-.124 2.067.946V16.77c0 1.07-1.257 1.645-2.067.946L4.632 14H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2.632Z" }),
        React.createElement("path", { d: "M13.043 12.957a1 1 0 0 1 0-1.414L14.586 10l-1.543-1.543a1 1 0 0 1 1.414-1.414L16 8.586l1.543-1.543a1 1 0 1 1 1.414 1.414L17.414 10l1.543 1.543a1 1 0 0 1-1.414 1.414L16 11.414l-1.543 1.543a1 1 0 0 1-1.414 0Z" })));
});
